import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';
import {
  LISTING_CODE_ALLOWED_INTEREST_BLOCKS,
  LISTING_CODE_ALLOWED_LEDGER_LETTERS,
  LISTING_CODE_ALLOWED_LEDGER_KINDS,
  LISTING_CODE_ALLOWED_LEDGER_CODES,
  LISTING_CODE_ALLOWED_ORDER_ASSOCIATIONS,
  LISTING_CODE_ALLOWED_TRANSACTIONS,
  LISTING_CODE_ALLOWED_WORKFLOWS,
  LISTING_CODE_ALLOWED_TYPES,
  LISTING_CODE_ALLOWED_PARTY_KINDS,
  LISTING_CODE_CHARGE_DESCRIPTIONS,
  LISTING_EXISTING_MUTATIONS,
  LISTING_EXISTING_QUERYS,
  LISTING_LOCKED_ACCOUNTING_AMOUNTS
} from 'utils/constants';

export type ListingEntry = {
  code: string;
  description: string;
};

export type GQLGetListingResponse = {
  getListing: {
    code: string;
    entries: ListingEntry[];
  };
};

export type ListingCode = typeof LISTING_CODE_ALLOWED_ORDER_ASSOCIATIONS
| typeof LISTING_CODE_ALLOWED_INTEREST_BLOCKS
| typeof LISTING_CODE_ALLOWED_TRANSACTIONS
| typeof LISTING_CODE_ALLOWED_WORKFLOWS
| typeof LISTING_CODE_ALLOWED_TYPES
| typeof LISTING_CODE_ALLOWED_LEDGER_LETTERS
| typeof LISTING_CODE_ALLOWED_LEDGER_KINDS
| typeof LISTING_CODE_ALLOWED_LEDGER_CODES
| typeof LISTING_CODE_ALLOWED_PARTY_KINDS
| typeof LISTING_CODE_CHARGE_DESCRIPTIONS
| typeof LISTING_EXISTING_MUTATIONS
| typeof LISTING_EXISTING_QUERYS
| typeof LISTING_LOCKED_ACCOUNTING_AMOUNTS

type GetListingParams = {
  code: ListingCode;
};

export const getListing = async (payload: GetListingParams) => {
  const query = gql`
    query GetListing($code: String!) {
      getListing(code: $code) {
        code
        entries {
          code
          description
        }
      }
    }
  `;

  const response = await graphQLClient().request<GQLGetListingResponse, GetListingParams>(
    query,
    payload
  );
  return response;
};
